import { render, staticRenderFns } from "./ProjectListHeader.vue?vue&type=template&id=12066ee0"
import script from "./ProjectListHeader.vue?vue&type=script&lang=js"
export * from "./ProjectListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports